import { getUserToken } from "../helpers/authHelper";
import api from "../api";

export async function FetchFranchiseList() {
  return await api({
    method: "get",
    data: "",
    url: `${process.env.REACT_APP_API_URL}/admin/Franchise/franchise-list`,
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
    },
  });
}

export async function DeleteFranchiseRecord(id) {
  return await api({
    method: "delete",
    data: "",
    url: `${process.env.REACT_APP_API_URL}/admin/Franchise/delete-franchise/${id}`,
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
    },
  });
}

export async function CreateFranchiseRecord(data) {
  return await api({
    method: "post",
    data: data,
    url: `${process.env.REACT_APP_API_URL}/admin/Franchise/create-franchise/`,
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
    },
    "content-type": "multipart/form-data",
  });
}

export async function EditFranchiseRecord(data) {
  return await api({
    method: "put",
    data: data,
    url: `${process.env.REACT_APP_API_URL}/admin/Franchise/edit-franchise/${data.id}`,
    headers: {
      Authorization: getUserToken(),
      "X-DomainID": localStorage.getItem("subdomainId") || "",
    },
    "content-type": "multipart/form-data",
  });
}
